import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const propTypes = {
    className: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    onStartDateChange: PropTypes.func.isRequired,
    onEndDateChange: PropTypes.func.isRequired
};

const defaultProps = {
    className: '',
    minDate: new Date(),
    maxDate: new Date(),
    startDate: new Date(),
    endDate: new Date()
};

function DateRangePicker({ className, minDate, maxDate, startDate, endDate, onStartDateChange, onEndDateChange }) {
    return (
        <div className={className}>
            <div>
                <label className="label-form margin-right-sm">
                    Start Date
                </label>
                <DatePicker
                    className="margin-right-md"
                    selected={startDate}
                    onChange={onStartDateChange}
                    minDate={minDate}
                    maxDate={maxDate}
                />
            </div>
            <div>
                <label className="label-form margin-right-sm">
                    End Date
                </label>
                <DatePicker
                    className="margin-right-md"
                    selected={endDate}
                    onChange={onEndDateChange}
                    minDate={minDate}
                    maxDate={maxDate}
                />
            </div>
        </div>
    );
}

DateRangePicker.propTypes = propTypes;
DateRangePicker.defaultProps = defaultProps;

export default DateRangePicker;